import { AnexoArquivoInput } from 'graphql/types.generated'

import {
  AnexoArquivoFormModel,
  AnexoArquivoRowModel,
  ArquivoAnexadoFromQuery,
  ArquivoAnexadoQueryModel,
} from './model-anexoArquivos'

export function convertAnexoArquivosToInput(anexoArquivos: ReadonlyArray<AnexoArquivoFormModel>): AnexoArquivoInput[] {
  return anexoArquivos?.map((anexoArquivo) => ({
    arquivoUuid: anexoArquivo.arquivoUuid,
    titulo: anexoArquivo.titulo,
    observacao: anexoArquivo.observacao,
    categoria: anexoArquivo.categoria,
  }))
}

export function convertAnexoArquivoRowToForm(row: AnexoArquivoRowModel): AnexoArquivoFormModel {
  return {
    arquivoUuid: row.arquivo.uuid,
    titulo: row.titulo,
    observacao: row.observacao,
    categoria: row.categoria,
    dataCriacao: row.arquivo.dataCriacao,
  }
}

export function convertAnexoArquivoQueryRetificacaoToForm(input: ArquivoAnexadoQueryModel): AnexoArquivoFormModel {
  const { dataCriacao, uuid } = input.arquivo

  return {
    arquivoUuid: uuid,
    categoria: input.categoria,
    titulo: input.titulo,
    observacao: input.observacao,
    dataCriacao,
  }
}

export function convertQueryToAnexoArquivoRowModel(
  raw: ReadonlyArray<ArquivoAnexadoFromQuery>
): AnexoArquivoRowModel[] {
  return raw.map((item) => {
    const { observacao, ...rest } = item

    return {
      ...rest,
      observacao: observacao ?? undefined,
    }
  })
}
